import React from 'react'
import { StyledQuestionBox, StyledQuestionBoxHeader } from '../../../styles'
import PreparedQuestionCardDropDownMenu from './PreparedQuestionCardDropDownMenu'
import { useDispatch } from 'react-redux'
import { StyledBox } from './styles'
import type { Question } from '../../../types'
import { shouldShowSchoolApprovedBadge } from '../shouldShowSchoolApprovedBadge'
import { getEditableQuestion, getSelectedQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import { type ISurveySection, setEditableQuestion, updateQuestionInSection } from '../../../../../store/slices/SurveyTemplateSlice'
import { Box } from '@mui/material'
import SchoolApprovedBadge from '../SchoolApprovedBadge'
import { useLocation } from 'react-router-dom'
import ROUTES from '../../../../../consts/paths'
import { PREFIX_FOLLOW_UP_FREE_RESPONSE_QUESTION_PROMPT } from '../../../constant'
import { red } from '@mui/material/colors'

interface PreparedQuestionCardWrapperProps {
  children: JSX.Element
  question: Question
  index?: number
  questionNumber?: number
  sectionIndex: number
  totalQuestionInSection: number
  section: ISurveySection
  isEditable?: boolean
  isSurveyTemplate?: boolean
}

const PreparedQuestionCardWrapper: React.FC<PreparedQuestionCardWrapperProps> = ({ questionNumber, children, question, index = 0, sectionIndex, totalQuestionInSection, section, isEditable, isSurveyTemplate = false }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()
  const selectedQuestion = getSelectedQuestion()
  const location = useLocation()
  const isAcademicRoute = location.pathname.includes(ROUTES.ACADEMIC_UNIT_ADDED_QUESTIONS)
  const isFollowUpQuestion = question.prompt.includes(PREFIX_FOLLOW_UP_FREE_RESPONSE_QUESTION_PROMPT)

  const handleEditableQuestion = (): void => {
    if (editableQuestion == null && !selectedQuestion && isEditable !== false) {
      dispatch(setEditableQuestion({ question, questionIndex: index, sectionIndex }))
    }
  }

  const handleChangeSchoolApproved = (isSchoolApproved: boolean): void => {
    if (isSurveyTemplate && index !== undefined) {
      dispatch(updateQuestionInSection({
        surveySectionId: section.surveySectionId,
        questionIndex: index,
        updatedQuestion: { ...question, isSchoolApproved }
      }))
    }
  }

  const showSchoolApprovedBadge = shouldShowSchoolApprovedBadge(
    isEditable,
    isSurveyTemplate,
    isAcademicRoute,
    isFollowUpQuestion,
    question
  )

  return (
    <StyledQuestionBox id={`${question.itemId}`}>
      <StyledQuestionBoxHeader>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {
            question.isRequired && <Box
              component="span"
              sx={{ color: red[600], fontSize: '20px' }}
            >
              *
            </Box>
          }
          Question {questionNumber}{isFollowUpQuestion && ' (Follow-up)'}
        </Box>

        <Box display='flex' flexDirection='row' alignItems='center'>
          {showSchoolApprovedBadge &&
            <SchoolApprovedBadge
              isSurveyTemplate={isSurveyTemplate}
              onClick={handleChangeSchoolApproved}
              isApproved={question.isSchoolApproved}
            />
          }
          <PreparedQuestionCardDropDownMenu isFollowUpQuestion={isFollowUpQuestion} question={question} questionIndex={index} sectionIndex={sectionIndex} totalQuestionInSection={totalQuestionInSection} section={section} />
        </Box>
      </StyledQuestionBoxHeader>
      <StyledBox onClick={handleEditableQuestion}>
        {children}
      </StyledBox>
    </StyledQuestionBox>
  )
}

export default PreparedQuestionCardWrapper
